/**
 * Pure helpers for the consent page (`/connect`): no React, no fetch, so the
 * decisions the page makes about its own address can be tested in node.
 */

/** True when the address carries an authorization request at all. A person who
 *  opens `/connect` by hand gets an explanation instead of a server error. */
export function hasAuthorizeQuery(search: string): boolean {
  return new URLSearchParams(search).has("client_id");
}

/** Every query parameter as a plain string, the shape the answer route reads. A
 *  repeated parameter keeps its first value. */
export function queryObject(search: string): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [key, value] of new URLSearchParams(search)) {
    if (!(key in out)) out[key] = value;
  }
  return out;
}

/** Which message to show for a refused request. The server writes its reasons in
 *  English, so the two the person meets most get their own translated line; for
 *  the rest (a request the app built wrong) a generic line leads and the server's
 *  reason follows as detail. */
export function refusalCopy(error: string): { key: string; showReason: boolean } {
  if (error === "invalid_client" || error === "invalid_redirect_uri") {
    return { key: `connect.errors.${error}`, showReason: false };
  }
  return { key: "connect.errors.generic", showReason: true };
}
